import React, { useState, useEffect } from "react";
import BookDemoModal from "./BookDemoModal";
import Footer from "./Footer";
import CompanyLoginModal from "./CompanyLoginModal";

import "animate.css/animate.min.css";
import "./Style.css";
import "./Odometer.css";
import "./Swiper.min.css";
import "./plugins/plugin-custom.js";

import "./main.js";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import { ArrowUp, ArrowUpRight, ChevronDown, List } from "react-bootstrap-icons";

// Reusable feature block component
const FeatureBlock = ({ icon, title, description, alignment }) => (
  <div
    className={`feature-block group ${alignment === "right" ? "right" : "left"
      }`}
  >
    <i
      className={`ph-fill ${icon} text-blue-600 rounded-full text-3xl group-hover:scale-110 transform transition-transform`}
    />
    <div className="feature-content">
      <h4 className="text-lg font-semibold mb-1 group-hover:text-blue-600 transition-colors">
        {title}
      </h4>
      <p className="text-sm text-gray-600 group-hover:text-gray-800 transition-colors">
        {description}
      </p>
    </div>
  </div>
);

const navSolutions = [
  { icon: "ph-users-three", title: "HR Operations", desc: "Manage employee lifecycle, org structure and all HR workflows in one place." },
  { icon: "ph-money-wavy", title: "Payroll & Finance", desc: "Automate salary processing, payslip generation and tax deductions." },
  { icon: "ph-shield-check", title: "Tax & Compliance", desc: "PF, PT, TDS and GST filings handled end-to-end without manual effort." },
  { icon: "ph-user-plus", title: "Talent Acquisition", desc: "Track candidates, issue offer letters and onboard new hires seamlessly." },
  { icon: "ph-receipt", title: "Invoice & Billing", desc: "Create professional invoices, quotations and manage client accounts." },
  { icon: "ph-fingerprint", title: "Attendance & Leaves", desc: "Monitor daily and monthly attendance with streamlined leave workflows." },
  { icon: "ph-files", title: "Document Generation", desc: "Experience letters, certificates and appraisal documents in seconds." },
  { icon: "ph-user-gear", title: "Employee Self-Service", desc: "Employees access payslips, apply leaves and update their own data." },
];



const whyCubPoints = [
  { icon: "ph-squares-four", title: "All-in-One Platform", desc: "HR, Payroll, Tax, Invoicing — one login, zero tool switching." },
  { icon: "ph-lightning", title: "Automation First", desc: "From salary calc to PDF letters, we automate the heavy lifting." },
  { icon: "ph-lock-key", title: "Secure by Design", desc: "Role-based access with full company-level data isolation." },
  { icon: "ph-trend-up", title: "Built to Scale", desc: "Grows from 10 to 10,000 employees without a single friction point." },
  { icon: "ph-file-arrow-down", title: "Instant Documents", desc: "Generate offer letters, payslips and certificates in one click." },
  { icon: "ph-check-circle", title: "Compliance Ready", desc: "PF, PT, TDS and GST workflows baked directly into the platform." },
  { icon: "ph-chats-circle", title: "Employee Experience", desc: "A self-service portal that cuts HR overhead and empowers your team." },
  { icon: "ph-rocket-launch", title: "Quick to Go Live", desc: "Get your entire HR operation running in days, not months." },
];

const LandingPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileSolutionsOpen, setIsMobileSolutionsOpen] = useState(false);
  const [isMobileWhyCubOpen, setIsMobileWhyCubOpen] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const leftFeatures = [
    {
      icon: "ph-users-three",
      title: "Employee Registration",
      description: "Capture essential employee details including documents.",
    },
    {
      icon: "ph-lock",
      title: "Role-Based Access Control",
      description: "Secure role-based HR access management.",
    },
    {
      icon: "ph-timer",
      title: "End-to-End Employee Management",
      description: "Automate onboarding to relieving.",
    },
  ];

  const rightFeatures = [
    {
      icon: "ph-fingerprint",
      title: "Attendance Tracking",
      description: "Monitor attendance accurately through HR Management.",
    },
    {
      icon: "ph-money-wavy",
      title: "Payroll Processing",
      description:
        "Automated salary, tax, payslip generations, ensuring precise and timely payments.",
    },
    {
      icon: "ph-handshake",
      title: "Client & Invoice Management",
      description: "Manage clients and create accurate invoices.",
    },
    {
      icon: "ph-user-gear",
      title: "Employee Self-Service (ESS)",
      description: "Allow employees to access and update their details.",
    },
  ];

  // Scroll to Top
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Function to open the mobile menu
  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  // Function to close the mobile menu
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // const companyLogos = [
  //   { id: 1, src: "assets/images/logo1.png", alt: "Company Logo 1" },
  //   { id: 2, src: "assets/images/logo2.png", alt: "Company Logo 2" },
  //   { id: 3, src: "assets/images/logo3.png", alt: "Company Logo 3" },
  //   { id: 4, src: "assets/images/logo2.png", alt: "Company Logo 4" }, // Duplicate for example
  //   { id: 5, src: "assets/images/logo3.png", alt: "Company Logo 5" }, // Duplicate for example
  //   { id: 6, src: "assets/images/logo1.png", alt: "Company Logo 6" },
  //   { id: 7, src: "assets/images/logo2.png", alt: "Company Logo 7" },
  //   { id: 8, src: "assets/images/logo3.png", alt: "Company Logo 8" },
  //   { id: 9, src: "assets/images/logo3.png", alt: "Company Logo 9" },
  //   { id: 10, src: "assets/images/logo2.png", alt: "Company Logo 10" },
  //   { id: 11, src: "assets/images/logo3.png", alt: "Company Logo 11" },
  //   { id: 12, src: "assets/images/logo1.png", alt: "Company Logo 12" },
  // ];

  return (
    <div className="landing-page">
      <header className="">
        <div className="top-0 left-0 right-0 z-50 py-3 header headerAbsolute 2">
          <div className="flex justify-between items-center container text-s1">
            <div className="flex justify-start items-center gap-3">
              {/* Mobile Menu Open Button */}
              <button
                className="lg:hidden text-3xl mobileMenuOpenButton"
                onClick={openMobileMenu} // Attach onClick handler
              >
                <List className="text-3xl" weight="regular" />
              </button>
              <a href=" ">
                <img src="assets/img/website/newDesCubLogo.png" alt="cub Hrm logo" className="h-[60px]" />
              </a>
            </div>
            {/* Desktop Navigation */}
            <nav className="max-lg:hidden">
              <ul className="flex justify-center items-center gap-3">
                <li>
                  <a
                    href=" "
                    className="menu hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg text-md"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg menu text-md"
                  >
                    About
                  </a>
                </li>

                {/* Solutions Mega Dropdown */}
                <li className="mega-nav-item">
                  <button className="mega-nav-trigger menu hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg text-md flex items-center gap-1">
                    Solutions <ChevronDown className="mega-nav-chevron" />
                  </button>
                  <div className="mega-dropdown solutions-dropdown">
                    <div className="mega-left">
                      <p className="mega-left-eyebrow">What We Offer</p>
                      <h3 className="mega-left-heading">Built for Modern HR Teams</h3>
                      <p className="mega-left-sub">One platform covering your entire workforce lifecycle — HR, Payroll, Tax and more.</p>
                      <div className="mega-left-tags">
                        <span className="mega-tag">Workforce</span>
                        <span className="mega-tag">Finance</span>
                        <span className="mega-tag">Compliance</span>
                      </div>
                    </div>
                    <div className="mega-right">
                      <p className="mega-right-heading">Solutions for every team</p>
                      <div className="mega-grid">
                        {navSolutions.map((s, i) => (
                          <div key={i} className="mega-card">
                            <i className={`ph-fill ${s.icon} mega-card-icon`} />
                            <div>
                              <p className="mega-card-title">{s.title}</p>
                              <p className="mega-card-desc">{s.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>

                {/* Why CUB Mega Dropdown */}
                <li className="mega-nav-item">
                  <button className="mega-nav-trigger menu hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg text-md flex items-center gap-1">
                    Why CUB <ChevronDown className="mega-nav-chevron" />
                  </button>
                  <div className="mega-dropdown whycub-dropdown">
                    <div className="mega-left whycub-left">
                      <p className="mega-left-eyebrow">Our Advantage</p>
                      <h3 className="mega-left-heading">The Smarter Way to Run HR</h3>
                      <p className="mega-left-sub">Trusted by growing companies to automate, secure and simplify HR operations.</p>
                      <div className="mega-left-stats">
                        <div className="mega-stat">
                          <span className="mega-stat-num">10x</span>
                          <span className="mega-stat-label">Faster Onboarding</span>
                        </div>
                      </div>
                    </div>
                    <div className="mega-right">
                      <p className="mega-right-heading">Reasons to choose CUB</p>
                      <div className="mega-grid">
                        {whyCubPoints.map((w, i) => (
                          <div key={i} className="mega-card">
                            <i className={`ph-fill ${w.icon} mega-card-icon whycub-icon`} />
                            <div>
                              <p className="mega-card-title">{w.title}</p>
                              <p className="mega-card-desc">{w.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <a
                    href="/pricing"
                    className="hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg menu text-md"
                  >
                    Pricing
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg menu text-md"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </nav>

            <div className="flex justify-end items-center gap-3 font-medium max-sm:hidden" style={{ marginRight: '-1rem' }}>
              <a
                href=" "
                className="flex justify-center max-sm:text-sm items-center gap-2 py-2 px-4 rounded-full border border-gray-400 text-s1 group font-medium text-md hover:border-s1 transition-colors duration-200"
                onClick={(e) => {
                  e.preventDefault();
                  openModal();
                }}
              >
                Log In
              </a>
              <a
                href="/anonymouseCmpRegistration"
                target="_blank"
                rel="noreferrer"
                className="flex justify-center max-sm:text-sm items-center gap-2 py-2 md:py-3 px-3 md:px-6 rounded-full bg-s1 border border-mainTextColor text-white group font-medium text-md"
              >
                Sign Up <ArrowUpRight
                  className="group-hover:rotate-[45deg] duration-500 text-base sm:text-xl lg:text-xl"
                  weight="bold"
                />
              </a>
              {showModal && <CompanyLoginModal onClose={closeModal} />}
            </div>
          </div>
        </div>

        {/* Mobile Menu Background Overlay */}
        <div
          className={`fixed top-0 left-0 bg-s1/80 h-full w-full lg:hidden duration-700 z-[998] mobileMenuBg ${isMobileMenuOpen ? "mobileMenuBgOpen" : "mobileMenuBgClose"
            }`}
          onClick={closeMobileMenu} // Click background to close
        ></div>

        {/* Mobile Menu / Sidebar */}
        <div
          className={`flex justify-start flex-col items-start gap-8 pb-10 lg:gap-20 fixed lg:hidden top-0 left-0 w-3/4 min-[500px]:w-1/2 h-full bg-s2 overflow-y-auto duration-700 z-[999] mobileMenu ${isMobileMenuOpen ? "mobileMenuOpen" : "mobileMenuClose"
            }`}
        >
          <div className="flex justify-between items-center w-full p-4 sm:p-8">
            <a href=" ">
              <img src="assets/img/website/newDesCubLogo.png" alt="logo" />
            </a>
            {/* Mobile Menu Close Button */}
            <button
              className="!text-3xl cursor-pointer mobileMenuCloseButton"
              onClick={closeMobileMenu} // Attach onClick handler
            >
              <span className="text-3xl" weight="regular">
                X
              </span>{" "}
              {/* Assuming 'ph ph-x' is Phosphor X icon */}
            </button>
          </div>

          <ul
            className="text-lg sm:text-xl flex gap-6 lg:gap-10 items-start flex-col pl-8 w-full pr-6"
            onClick={closeMobileMenu}
          >
            <li>
              <a href=" " className="menu-hover hover:after:border-p1">
                Home
              </a>
            </li>
            <li>
              <a href=" " className="menu-hover hover:after:border-p1">
                About
              </a>
            </li>

            {/* Mobile Solutions Accordion */}
            <li className="w-full" onClick={(e) => e.stopPropagation()}>
              <button
                className="mobile-mega-toggle"
                onClick={() => setIsMobileSolutionsOpen((v) => !v)}
              >
                Solutions <ChevronDown className={`mobile-mega-chevron ${isMobileSolutionsOpen ? "open" : ""}`} />
              </button>
              {isMobileSolutionsOpen && (
                <div className="mobile-mega-list">
                  {navSolutions.map((s, i) => (
                    <div key={i} className="mobile-mega-item">
                      <i className={`ph-fill ${s.icon} mobile-mega-icon`} />
                      <span className="mobile-mega-label">{s.title}</span>
                    </div>
                  ))}
                </div>
              )}
            </li>

            {/* Mobile Why CUB Accordion */}
            <li className="w-full" onClick={(e) => e.stopPropagation()}>
              <button
                className="mobile-mega-toggle"
                onClick={() => setIsMobileWhyCubOpen((v) => !v)}
              >
                Why CUB <ChevronDown className={`mobile-mega-chevron ${isMobileWhyCubOpen ? "open" : ""}`} />
              </button>
              {isMobileWhyCubOpen && (
                <div className="mobile-mega-list">
                  {whyCubPoints.map((w, i) => (
                    <div key={i} className="mobile-mega-item whycub-mobile-item">
                      <i className={`ph-fill ${w.icon} mobile-mega-icon whycub-mobile-icon`} />
                      <span className="mobile-mega-label">{w.title}</span>
                    </div>
                  ))}
                </div>
              )}
            </li>

            <li>
              <a href="/pricing" className="menu-hover hover:after:border-p1">
                Pricing
              </a>
            </li>
            <li>
              <a href=" " className="menu-hover hover:after:border-p1">
                Contact Us
              </a>
            </li>
            <li>
              <a
                href=" "
                className="hover:header_menu_shadow duration-700 px-2 py-3 rounded-lg menu"
              >
                Sign Up
              </a>
            </li>
          </ul>
        </div>
      </header>

      <section className="bg-repeat stp-20 bg-p1 overflow-hidden">
        <img
          src="assets/images/hero_bg_element1.png"
          alt="element"
          className="absolute top-0 left-0 xxxl:left-36 max-lg:w-[300px] max-xxl:w-[500px] max-md:hidden"
        />
        <img
          src="assets/images/hero_bg_element2.png"
          alt="element"
          className="absolute top-0 right-0 max-xxl:w-[300px] max-sm:hidden"
        />
        <div className="absolute -left-[200px] -bottom-1/2 bg-white blur-[200px] rounded-[1176px] max-w-full lg:w-[1176px] h-[1176px] overflow-hidden"></div>
        <div className="xxl:ml-[calc((100%-1296px)/2)] lg:max-xxl:py-10 max-xxl:container relative z-20 max-lg:pt-15 text-s1 grid grid-cols-12">
          <img
            src="assets/images/hero_bg_element3.png"
            alt="element"
            className="absolute top-4 left-1/3 max-sm:hidden"
          />
          <div className="col-span-12 lg:col-span-5 flex flex-col justify-center gap-2">
            <p className="uppercase text-base lg:text-xl font-semibold animate__animated animate__fadeInUp">
              Efficiency HRM and workforce mastery
            </p>
            <div className="display-2">
              Automated <span className="text-s3 inline-flex">HRM</span>
              <br />
            </div>
            <div className="display-5">That Grows With You</div>
            <p className="max-w-[550px]"></p>
            <div className="flex justify-start items-center gap-4 pt-6 lg:pt-8 pb-4">
              <button
                onClick={() => setShowDemoModal(true)}
                className="flex justify-center items-center gap-2 py-2 lg:py-3 px-4 lg:px-6 rounded-full bg-s2 border border-mainTextColor text-mainTextColor group font-medium hover:bg-white/10 transition-colors duration-200"
              >
                Request a Demo
                <ArrowUpRight className="group-hover:rotate-[45deg] duration-500 text-base sm:text-xl" />
              </button>
              <a
                href="/anonymouseCmpRegistration"
                className="underline font-medium text-white hover:text-s3 duration-200"
              >
                Sign Up Free
              </a>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7">
            <img src="assets/images/heroine1_iilus.png" alt="illustration" />
          </div>
        </div>
      </section>
      <section className="bg-white stp-15 sbp-15 relative">
        {/* <img
          src="assets/images/circleIcon.png"
          alt="circle icon"
          className="absolute top-10 left-0 max-xxl:hidden xxl:-left-72 xxxl:-left-40"
        /> */}
        <img
          src="assets/images/sliceIcon.png"
          alt="slice icon"
          className="absolute left-0 sm:left-2 lg:right-10 top-10 xl:top-32 max-md:h-[80px]"
          style={{ transform: "rotateY(180deg)" }}
        />
        <img
          src="assets/images/sliceIcon.png"
          alt="slice icon"
          className="absolute right-0 sm:right-2 lg:right-10 top-10 xl:top-32 max-md:h-[80px]"
        />

        <div className="container z-10 relative">
          <div className="flex justify-center items-center">
            <div className="flex justify-center items-center max-xxl:overflow-hidden">
              <div className="max-w-[700px] text-center flex justify-center items-center flex-col">
                <h1 className="display-4  pb-4 lg:pb-6 wow animate__animated animate__fadeInDown">
                  The CUB HRM solution
                </h1>
                <p className="text-bodyText wow animate__animated animate__fadeInDown">
                  CUB delivers advanced HR resource modules with a user-friendly interface and powerful features.
                  It is easy to implement, configure, and operate, ensuring a seamless HR management experience.
                </p>
              </div>
            </div>
          </div>

          {/* Process Steps */}
          <div className="relative flex justify-center items-center mt-5 gap-4 flex-wrap">
            {/* Reusable step card component */}
            {[
              { src: "assets/images/personsignup_icon.png", label: "Sign Up" },
              { src: "assets/images/signup_icon.png", label: "Login" },
              { src: "assets/images/configureIcon.png", label: "Configure" },
              { src: "assets/images/whyAccoupayCard_3.jpg", label: "Get Started" }
            ].map((step, index) => (
              <React.Fragment key={index}>
                <div className="step-card bg-white text-center text-s1 flex flex-col items-center justify-center w-[120px] h-[120px] p-2">
                  <img
                    src={step.src}
                    alt={`${step.label} Icon`}
                    className="w-[60px] h-[60px] mb-2 object-contain"
                  />
                  <span className="text-[14px] font-medium">{step.label}</span>
                </div>

                {index < 3 && (
                  <div className="arrow">
                    <span className="arrow-icon text-2xl">→</span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          {/* 
        <div className="mt-8 text-center text-xl text-gray-600 font-medium">
          <p className="inline-block border-t-2 border-dashed border-gray-400 pt-4 mt-6">
            🎉 Perfect! You built it.
          </p>
        </div> */}
        </div>
      </section>

      <section id="about" className=" stp-10 sbp-10 overflow-hidden bg-p1">
        <div className="container">
          <div className="flex justify-between items-end gap-6 max-lg:flex-col max-lg:items-start">
            <div className="max-w-100 flex flex-col items-center w-full">

              <div className="flex flex-row w-full pt-4 items-center gap-6 max-md:flex-col">
                {/* Image */}
                <div className="w-50 flex justify-center items-center overflow-hidden self-stretch max-md:w-full">
                  <img
                    src="assets/images/solution_illustrations.png"
                    alt="HRM Illustration"
                    className="img-hover-delay w-full object-contain max-w-xs"
                  />
                </div>
                {/* Content */}
                <div className="w-50 flex flex-col justify-start items-start max-md:w-full max-md:items-center">

                  {/* About Us Button */}
                  <p className="bg-white py-3 px-5 rounded-full text-dark wow animate__ animate__fadeInUp animated  font-semibold">
                    About CUB HRM
                  </p>
                  {/* Image & Content */}
                  <h1 className="heading-1 pb-2 max-md:text-center w-full text-white pt-3">
                    Consolidate HRM Processing
                  </h1>
                  <h2 className="max-md:text-center w-full text-light">
                    For Small and Growing Businesses
                  </h2>
                  <div className="py-3 lg:py-10 w-full">
                    <p className="text-bodyText max-md:text-center text-white">
                      CUB HRM is a user-friendly, intuitive Human Resource Management System (HRMS) tailored specifically for small, medium, and startup businesses in India. With a strong focus on efficient payroll management, CUB HRM provides a comprehensive suite of tools designed to streamline your HR operations.
                    </p>
                    <p className="text-bodyText mt-2 max-md:text-center text-white">
                      From accurate and timely salary processing to automated tax and statutory deductions (including TDS, PF, and ESI), CUB HRM ensures hassle-free payroll generation. Create and distribute professional payslips with ease, and manage employee data securely—all in one place.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* VBRS IT */}
      {/* <div className="flex flex-row w-full stp-15 gap-6">
                <div className="w-50 bg-softBg1 flex flex-col justify-start items-start p-4">
                  <p className="text-bodyText pb-1">
                    <b>VBRS IT </b> Solutions designed a fast and effective{" "}
                    <b>HRM </b>system that streamlines your <br />{" "}
                    <b>HR Management process </b>.
                  </p>

                  <p className="text-bodyText mt-1 pb-1">
                    As we scaled, we encountered internal challenges in managing
                    employee records, attendance, and payroll...
                  </p>

                  <p className="text-bodyText mt-2 pb-1">
                    <b>VBRS IT Solutions</b> founded in <b>2014</b>, is a
                    forward-thinking technology company serving more than 50
                    clients across India. At <b>VBRS </b>, we are committed to
                    delivering practical, innovative, and user-centric digital
                    solutions...
                  </p>

                  <div className="flex flex-col items-start mt-4">
                    <span className="text-bodyText">For more details...</span>
                    <a
                      className="flex justify-center items-center gap-3 md:py-3 px-3 md:px-6 rounded-full bg-s2 border border-mainTextColor text-mainTextColor group font-medium"
                      href="https://vbrsit.com"
                    >
                      Visit Us
                      <span className="group-hover:rotate-[45deg] duration-500 text-base sm:text-xl lg:text-2xl !leading-[0]">
                        <i className="ph-bold ph-arrow-up-right"></i>
                      </span>
                    </a>
                  </div>
                </div>
                <div className="w-50 flex bg-strokeGreen justify-center items-start overflow-hidden self-stretch">
                  <img
                    src="assets/img/VBRSIT-logo.png"
                    alt="VBRS IT Logo"
                    className="hover:scale-110 duration-500 w-full object-contain"
                  />
                </div>
              </div> */}
      {/* </div> */}
      {/* <p className="text-bodyText max-w-[500px]">
        Your dependable guide to achieving freedom from manual HR work and
        building that perfect workplace you have always aspired to build. Your
        dependable guide to achieving freedom.
      </p> */}
      {/* </div> */}
      {/* <div className="grid grid-cols-12 gap-6 stp-15">
            <div className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp">
              <div className="">
                <img src="assets/images/whyAccoupayCard_1.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Hire or relocate team member with in house visa support
              </h4>
            </div>
            <div
              className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay=".2s"
            >
              <div className="">
                <img src="assets/images/whyAccoupayCard_2.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Create complaint contracts with a single click
              </h4>
            </div>
            <div
              className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay=".4s"
            >
              <div className="">
                <img src="assets/images/whyAccoupayCard_3.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Send equipment worldwide, without the hassle
              </h4>
            </div>
            <div
              className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay=".6s"
            >
              <div className="">
                <img src="assets/images/whyAccoupayCard_4.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Offer country- specific benefits at competitive rates
              </h4>
            </div>
            <div
              className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay=".8s"
            >
              <div className="">
                <img src="assets/images/whyAccoupayCard_5.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Provide your team with co-working access via work
              </h4>
            </div>
            <div
              className="col-span-12 sm:col-span-6 lg:col-span-4 bg-white p-6 xl:py-10 xl:px-15 flex flex-col items-center border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="1s"
            >
              <div className="">
                <img src="assets/images/whyAccoupayCard_6.png" alt="image" />
              </div>
              <h4 className="pt-8 heading-4">
                Save time using advance integrations
              </h4>
            </div>
          </div> */}

      {/* ── Screenshot Mosaic ── */}
      <section className="sc-mosaic-section">
        <div className="sc-mosaic-glow" />
        <div className="container">
          <div className="sc-mosaic-header">
            <span className="section-eyebrow">See It In Action</span>
            <h2 className="sc-mosaic-title">Everything your HR team needs, in one place</h2>
            <p className="sc-mosaic-subtitle">A real look at the CUB HRM platform — built for speed, clarity and daily use.</p>
          </div>

          <div className="sc-mosaic-stage">
            {/* ── Scattered mini-cards ── */}
            <div className="sc-mini-card sc-mini-card--tl" title="Dashboard">
              <div className="sc-mini-bar">
                <span className="sc-mini-dot sc-mini-dot--r" /><span className="sc-mini-dot sc-mini-dot--y" /><span className="sc-mini-dot sc-mini-dot--g" />
                <span className="sc-mini-label">Dashboard</span>
              </div>
              <img src="assets/img/website/dashboard.png" alt="Dashboard" className="sc-mini-img" />
            </div>

            <div className="sc-mini-card sc-mini-card--tr" title="Payroll">
              <div className="sc-mini-bar">
                <span className="sc-mini-dot sc-mini-dot--r" /><span className="sc-mini-dot sc-mini-dot--y" /><span className="sc-mini-dot sc-mini-dot--g" />
                <span className="sc-mini-label">Payroll</span>
              </div>
              <img src="assets/img/website/payslipView.png" alt="Payroll" className="sc-mini-img" />
            </div>

            {/* ── Hero center card ── */}
            <div className="sc-hero-card">
              <div className="sc-hero-bar">
                <div className="sc-hero-dots">
                  <span className="sc-dot sc-dot--red" /><span className="sc-dot sc-dot--yellow" /><span className="sc-dot sc-dot--green" />
                </div>
                <div className="sc-hero-url">
                  <i className="ph ph-lock-simple sc-lock" /> app.cubhrm.com
                </div>
                <span className="sc-hero-tab">Employees</span>
              </div>
              <img src="assets/img/website/empView.png" alt="Employee View" className="sc-hero-img" />
            </div>

            <div className="sc-mini-card sc-mini-card--bl" title="Attendance">
              <div className="sc-mini-bar">
                <span className="sc-mini-dot sc-mini-dot--r" /><span className="sc-mini-dot sc-mini-dot--y" /><span className="sc-mini-dot sc-mini-dot--g" />
                <span className="sc-mini-label">Attendance</span>
              </div>
              <img src="assets/img/website/attendanceView.png" alt="Attendance" className="sc-mini-img" />
            </div>

            <div className="sc-mini-card sc-mini-card--br" title="Calendar">
              <div className="sc-mini-bar">
                <span className="sc-mini-dot sc-mini-dot--r" /><span className="sc-mini-dot sc-mini-dot--y" /><span className="sc-mini-dot sc-mini-dot--g" />
                <span className="sc-mini-label">Att. Calendar</span>
              </div>
              <img src="assets/img/website/calendar.png" alt="Calendar" className="sc-mini-img" />
            </div>

            <div className="sc-mini-card sc-mini-card--bc" title="Custom Template">
              <div className="sc-mini-bar">
                <span className="sc-mini-dot sc-mini-dot--r" /><span className="sc-mini-dot sc-mini-dot--y" /><span className="sc-mini-dot sc-mini-dot--g" />
                <span className="sc-mini-label">Templates</span>
              </div>
              <img src="assets/img/website/customTemplate.png" alt="Custom Template" className="sc-mini-img" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white stp-15 sbp-15 pt-6 overflow-hidden">
        <div className="container">
          <div className="flex justify-between items-center gap-6 max-lg:flex-col max-lg:items-start">
            <div className="max-w-[600px] flex justify-center items-start flex-col">
              <p className="bg-p1 py-3 px-5 rounded-full text-white wow animate__animated animate__fadeInUp  font-semibold">
                What CUB HRM Offers
              </p>
              <h1 className="display-4 pt-4 wow animate__animated animate__fadeInDown">
                Perfect solutions for your business
              </h1>
            </div>
            <p className="text-bodyText max-w-[500px]">
              CUB HRM is a comprehensive Human Resource Management System
              tailored for small and growing businesses. It simplifies and
              automates critical HR processes,empowering teams to focus on
              growth while ensuring compliance and operational efficiency.
            </p>
          </div>
        </div>
        <div id="services">
          <div className="services-grid">
            {/* Left Feature Stack */}
            <div className="features-column features-left">
              {leftFeatures.map((feature, idx) => (
                <FeatureBlock key={idx} {...feature} alignment="right" />
              ))}
            </div>

            {/* Center Image */}
            <div className="services-image">
              <img
                src="assets/images/breadcrumb_img_18.png"
                alt="Features Illustration"
                className="center-image"
              />
            </div>

            {/* Right Feature Stack */}
            <div className="features-column features-right">
              {rightFeatures.map((feature, idx) => (
                <FeatureBlock key={idx} {...feature} alignment="left" />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* <section
     style={{ backgroundImage: "url('assets/images/counter_bg.png')" }}
      className="bg-cover stp-30 sbp-30 relative"
    >
      <div
        className="container text-white flex justify-between items-center gap-8 sm:gap-4 md:gap-8 lg:gap-16 max-sm:flex-col"
      >
        <div className="text-center max-w-[280px]">
          <p className="display-4 pb-3 flex justify-center items-center">
            <span className="odometer" data-odometer-final="63">0</span>
            <span>hrs</span>
          </p>
          <p>
            Average time saved per month running HRM and HR after switching
            to Cub Hrm.
          </p>
        </div>
        <div className="h-[120px] w-[2px] bg-white/70 mt-8 max-sm:hidden"></div>
        <div className="text-center max-w-[280px]">
          <p className="display-4 pb-3 counters flex justify-center items-center">
            <span>$</span
            ><span className="odometer" data-odometer-final="264589">0</span>
          </p>
          <p>
            Average savings made per year running HRM and HR after switching
            to Cub Hrm.
          </p>
        </div>
        <div className="h-[120px] w-[2px] bg-white/70 mt-8 max-sm:hidden"></div>
        <div className="text-center max-w-[280px]">
          <p className="display-4 pb-3 counters flex justify-center items-center">
            <span className="odometer" data-odometer-final="8">0</span
            ><span>Weeks</span>
          </p>
          <p>average time it takes to switch to Cub Hrm - and often less</p>
        </div>
      </div>
    </section> */}

      {/* <section id="services" className="stp-30 sbp-30">
        <div className="container">
          <div className="flex justify-center items-center">
            <div className="flex justify-center items-center max-xxl:overflow-hidden">
              <div className="max-w-[700px] text-center flex justify-center items-center flex-col">
                <p className="bg-p1 py-2 sm:py-3 px-5 rounded-full text-white wow animate__animated animate__fadeInUp">
                  Services
                </p>
                <h1 className="display-4 pt-4 pb-4 lg:pb-6 wow animate__animated animate__fadeInDown">
                  What CUB HRM Offers
                </h1>
                <p className="text-bodyText  wow animate__animated animate__fadeInUp">
                  CUB HRM is a comprehensive Human Resource Management System
                  tailored for small and growing businesses. It simplifies and
                  automates critical HR processes, empowering teams to focus on
                  growth while ensuring compliance and operational efficiency.
                </p>
              </div>
            </div>
          </div>
         <div className="grid grid-cols-12 gap-1 stp-15">
  <div className="col-span-12 flex gap-1 items-stretch">
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      id="employeeRegistration"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center text-s1 pb-5 mt-3 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-users-three"></i>
        </div>
        <h4 className="heading-4 pb-5">Employee Registration</h4>
        <p className="text-bodyText pb-6">
          Capture essential employee details including personal,
          employment, and banking information, with seamless document uploads.
        </p>
      </div>
    </div>
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".2s"
      id="roleBasedAccessControl"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-lock"></i>
        </div>
        <h4 className="heading-4 pb-5">Role-Based Access Control</h4>
        <p className="text-bodyText pb-6">
          Define and manage user roles (Admin, HR, Accountant, Employee),
          ensuring secure and structured access to HR functions.
        </p>
      </div>
    </div>
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".4s"
      id="#endtoend"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-timer"></i>
        </div>
        <h4 className="heading-4 pb-5">End-to-End Employee Management</h4>
        <p className="text-bodyText pb-6">
          Automate the complete employee lifecycle—from onboarding
          to relieving—with secure document handling and compliance tracking.
        </p>
      </div>
    </div>
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".6s"
      id="attendanceTracking"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-fingerprint"></i>
        </div>
        <h4 className="heading-4 pb-5">Attendance Tracking</h4>
        <p className="text-bodyText pb-6">
          Accurately monitor and record employee attendance with integrated tools.
        </p>
      </div>
    </div>
  </div>
  <div className="col-span-12 flex justify-center gap-1 mt-4 items-stretch">
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".4s"
      id="payrollProcessing"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-money-wavy"></i>
        </div>
        <h4 className="heading-4 pb-5">Payroll Processing</h4>
        <p className="text-bodyText pb-6">
          Automate salary calculations, tax deductions, payslip generation,
          and direct salary deposits—ensuring precise and timely payments.
        </p>
      </div>
    </div>
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".6s"
      id="c&iManagement"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:border-mainTextColor duration-700 hover:bg-s2 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-handshake"></i>
        </div>
        <h4 className="heading-4 pb-5">Client & Invoice Management</h4>
        <p className="text-bodyText pb-6">
          Store client details securely and generate invoices based on work hours or contract terms,
          reducing billing errors.
        </p>
      </div>
    </div>
    <div
      className="col-span-12 sm:col-span-6 lg:col-span-3 wow animate__animated animate__fadeInUp"
      data-wow-duration="1.3s"
      data-wow-delay=".4s"
      id="essPortal"
    >
      <div className="bg-softBg1 p-2 xl:p-8 flex flex-col border border-white group hover:bg-s2 hover:border-mainTextColor duration-700 h-full max-w-[280px]">
        <div className="text-4xl text-center mt-3 text-s1 pb-5 group-hover:text-mainTextColor duration-500">
          <i className="ph-fill ph-user-gear"></i>
        </div>
        <h4 className="heading-4 pb-5">Employee Self-Service(ESS) Portal</h4>
        <p className="text-bodyText pb-6">
          Empower employees to access pay slips, tax documents, company policies,
          and update their personal information independently.
        </p>
      </div>
    </div>
  </div>
</div>
         <div className="container mx-auto px-4">
  <div className="flex flex-wrap w-full gap-0">
    <div className="flex w-full justify-start flex-wrap gap-1">
      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-users-three"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Employee Registration
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Capture essential employee details including personal, employment, and banking information, with seamless document uploads.
          </p>
        </div>
      </div>

      <div className="w-[250px] min-h-[250px] relative group p-6 bg-white border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-lock"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Role-Based Access Control
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Define and manage user roles (Admin, HR, Accountant, Employee), ensuring secure and structured access to HR functions.
          </p>
        </div>
      </div>

      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-timer"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          End-to-End Employee Management
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Automate the complete employee lifecycle—from onboarding to relieving—with secure document handling and compliance tracking.
          </p>
        </div>
      </div>

      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-fingerprint"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Attendance Tracking
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Accurately monitor and record employee attendance with integrated tools.
          </p>
        </div>
      </div>
    </div>

    <div className="flex w-full justify-center flex-wrap gap-4 mt-6">
      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-money-wavy"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Payroll Processing
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Automate salary calculations, tax deductions, payslip generation, and direct salary deposits—ensuring precise and timely payments.
          </p>
        </div>
      </div>

      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-handshake"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Client & Invoice Management
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Store client details securely and generate invoices based on work hours or contract terms, reducing billing errors.
          </p>
        </div>
      </div>

    
      <div className="w-[250px] min-h-[250px] relative group p-6 bg-softBg1 border border-softBg1 hover:bg-s2 hover:border-mainTextColor duration-500 overflow-hidden cursor-pointer">
        <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white z-10 relative">
          <i className="ph-fill ph-person"></i>
        </div>
        <h4 className="heading-4 pt-6 text-mainTextColor font-semibold z-10 relative">
          Employee Self-Service (ESS) Portal
        </h4>
        <div className="absolute inset-0 bg-white bg-opacity-95 p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 overflow-y-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            Empower employees to access pay slips, tax documents, company policies, and update their personal information independently.
          </p>
        </div>
      </div>
    </div>
  </div>
           </div> 
        </div>
      </section> */}

      {/* <div className="flex justify-between items-center gap-6 md:gap-4 lg:gap-6 stp-15 relative max-md:flex-col">
        {/* <img
              src="assets/images/stepArrow1.png"
              alt="image"
              className="absolute top-28 right-[22%] max-xxl:right-[23%] max-xxl:top-24 max-xxl:w-[200px] max-lg:right-[25%] max-lg:w-[100px] max-md:hidden"
            />
            <img
              src="assets/images/stepArrow2.png"
              alt="image"
              className="absolute top-16 left-[21%] max-xxl:top-20 max-xxl:left-[23%] max-xxl:w-[200px] max-lg:left-[25%] max-lg:w-[100px] max-md:hidden"
            />

            <div className="flex justify-center items-center text-center flex-col max-w-[350px]">
              <div className="text-s1 bg-softBg border border-strokeColor rounded-full p-6 lg:p-7 text-3xl lg:text-5xl">
                <i className="ph-fill ph-file-plus"></i>
              </div>
              <h4 className="heading-4 pt-8 pb-6">Create An Account</h4>
              <p className="text-bodyText">
                Join our platform effortlessly! Streamlined user registration
                with secure verification.
              </p>
            </div>
            <div className="flex justify-center items-center text-center flex-col max-w-[350px]">
              <div className="text-s1 bg-softBg border border-strokeColor rounded-full p-6 lg:p-7 text-3xl lg:text-5xl">
                <i className="ph-fill ph-user"></i>
              </div>
              <h4 className="heading-4 pt-8 pb-6">Add Your Employees</h4>
              <p className="text-bodyText">
                Join our platform effortlessly! Streamlined user registration
                with secure verification.
              </p>
            </div>
            <div className="flex justify-center items-center text-center flex-col max-w-[350px]">
              <div className="text-s1 bg-softBg border border-strokeColor rounded-full p-6 lg:p-7 text-3xl lg:text-5xl">
                <i className="ph-fill ph-hand-coins"></i>
              </div>
              <h4 className="heading-4 pt-8 pb-6">Run Your First HRM</h4>
              <p className="text-bodyText">
                Join our platform effortlessly! Streamlined user registration
                with secure verification.
              </p>
            </div> 
      </div> */}
      {/* <section className="stp-30 sbp-30">


        {/* Card 2
            <div className="w-full max-w-[280px] hover:bg-s2 border hover:border-mainTextColor duration-500 min-h-[250px] flex flex-col p-6 border-white">
              <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-softBg1">
                <i className="ph-fill ph-money"></i>
              </div>
              <h4 className="heading-4 pt-6">Tax Software Integration</h4>
              <div className="flex justify-end w-full pt-10 text-xl font-medium">
                <a href="all-services.html" className="bg-white p-2 rounded-full shadow2">
                  <i className="ph ph-arrow-right"></i>
                </a>
              </div>
            </div>

            {/* Card 3 *
        <div className="w-full max-w-[280px] hover:bg-s2 border hover:border-mainTextColor duration-500 min-h-[250px] flex flex-col p-6 bg-softBg1 border-softBg1">
          <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white">
            <i className="ph-fill ph-users-three"></i>
          </div>
          <h4 className="heading-4 pt-6">Expense Management</h4>
          <div className="flex justify-end w-full pt-10 text-xl font-medium">
            <a
              href="all-services.html"
              className="bg-white p-2 rounded-full shadow2"
            >
              <i className="ph ph-arrow-right"></i>
            </a>
          </div>
        </div>

        {/* Card 4 *
        <div className="w-full max-w-[280px] hover:bg-s2 border hover:border-mainTextColor duration-500 min-h-[250px] flex flex-col p-6 border-white">
          <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-softBg1">
            <i className="ph-fill ph-timer"></i>
          </div>
          <h4 className="heading-4 pt-6">Time Tracking Systems</h4>
          <div className="flex justify-end w-full pt-10 text-xl font-medium">
            <a
              href="all-services.html"
              className="bg-white p-2 rounded-full shadow2"
            >
              <i className="ph ph-arrow-right"></i>
            </a>
          </div>
        </div>

        {/* Card 5 *
        <div className="w-full max-w-[280px] hover:bg-s2 border hover:border-mainTextColor duration-500 min-h-[250px] flex flex-col p-6 bg-softBg1 border-softBg1">
          <div className="text-4xl rounded-full text-s1 leading-[0] p-4 bg-white">
            <i className="ph-fill ph-handshake"></i>
          </div>
          <h4 className="heading-4 pt-6">Customer Relationship</h4>
          <div className="flex justify-end w-full pt-10 text-xl font-medium">
            <a
              href="all-services.html"
              className="bg-white p-2 rounded-full shadow2"
            >
              <i className="ph ph-arrow-right"></i>
            </a>
          </div>
        </div>
      </section> */}

      <div className="bg-p1 pt-4 pb-5 overflow-hidden">
        <div className="max-xxl:container xxl:ml-[calc((100%-1296px)/2)] flex justify-between text-white sm:max-xxl:gap-6 max-lg:flex-col">
          <div className="flex flex-col justify-center items-start w-full lg:max-xxl:w-1/2 xxl:max-w-[550px] max-xxl:pb-8 max-xxl:overflow-hidden">
            {/* <p className="text-lg font-medium underline wow animate__animated animate__fadeInUp">
              Experience Cub Hrm
            </p> */}

            <h1 className="display-4 pb-4 pt-4 wow animate__animated animate__fadeInDown text-white">
              We’ve got everything you need?
            </h1>

            <p className="pb-8 wow animate__animated animate__fadeInUp text-md">
              We're here to help you streamline your HR and payroll processes.
              Reach out to our team for more information about CUB HRM and how
              it can benefit your organization
            </p>

            {/* <a
              href="#contact"
              className="flex justify-center max-sm:text-sm items-center gap-3 py-2 md:py-3 px-3 md:px-6 rounded-full bg-s2 border border-mainTextColor text-mainTextColor group font-medium"
            >
              Contact Us
              <span className="group-hover:rotate-[45deg] duration-500 text-base sm:text-xl lg:text-2xl">
                <i className="ph-bold ph-arrow-up-right"></i>
              </span>
            </a> */}
          </div>
          <div className="w-full lg:max-xxl:w-1/2 self-stretch flex justify-center max-xxl:items-center lg:pt-10 wow animate__animated animate__fadeInUp">
            <img
              src="assets/images/contact_illus.png"
              alt="pic"
              className="object-cover img-fluid"
            />
          </div>
        </div>
      </div>

      {/* <section id="contact" className="sbp-30 overflow-hidden">
        <div className="container">
          <div className="flex justify-center items-center">
            <div className="flex justify-center items-center max-xxl:overflow-hidden">
              <div className="max-w-[700px] text-center flex justify-center items-center flex-col">
                <p className="bg-p1 py-2 mt-2 sm:py-3 px-5 rounded-full text-white wow animate__animated animate__zoomIn">
                  Contact
                </p>

                <h1 className="display-4 pt-4 pb-4 lg:pb-6 wow animate__animated animate__fadeInUp">
                  For Any Queries
                </h1>

                <p className="text-bodyText wow animate__animated animate__fadeInDown">
                  We’re here to help you simplify and modernize your HR and
                  payroll processes. Get in touch with us to learn more about
                  how CUB HRM can benefit your business.
                </p>
              </div>
            </div>
          </div>
           <div
              className="col-span-12 min-[450px]:col-span-6 md:col-span-3 wow animate__animated animate__fadeInUp"
              data-wow-duration="1.3s"
            >
              <div className="flex justify-center items-center flex-col">
                <div className="text-7xl text-s1">
                  <i className="ph-fill ph-binoculars"></i>
                </div>
                <h4 className="heading-4 pb-4 pt-3">Compare Cub Hrm</h4>
                <p className="pb-5 text-center">
                  Explore how Cub Hrm stands out. Check our comparison.
                </p>
                <a href=" " className="text-s1 underline font-medium">
                  Compare Cub Hrm
                </a>
              </div>
            </div> 
          <div className="flex flex-wrap md:flex-nowrap justify-between items-start gap-6 border-t pt-10">
            <div className="flex-1 flex flex-col gap-8 pr-6 border-r md:border-r border-gray-300">
              <div>
                <div className="text-4xl text-s1 mb-2">
                  <i className="ph-fill ph-envelope-simple"></i>
                </div>
                <h4 className="heading-4 pb-2">Mail Us</h4>
                <p className="text-s1"> 📧 info@cubhrm.com</p>
              </div>
              <div>
                <div className="text-4xl text-s1 mb-2">
                  <i className="ph-fill ph-headset"></i>
                </div>
                <h4 className="heading-4 pb-2">Give Us a Ring</h4>
                <p className="text-s1">📞 +91 97056 78967</p>
              </div>
            </div>
            <div className="flex-1 pl-6">
              <div className="text-4xl text-s1 mb-2">
                <i className="ph-fill ph-address-book"></i>
              </div>
              <h4 className="heading-4 pb-2">Address</h4>
              <p className="text-s1">
                10th Floor, Unit #117, Techno-1, Sy. No: 86, 87(P), 88/1,
                Raidurg,
                <br />
                Serilingampally, Ranga Reddy District,
                <br />
                Telangana – 500081
              </p>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="relative after:absolute after:bg-mainTextColor after:bottom-0 after:right-0 after:left-0 after:h-1/2 overflow-hidden">
  <div className="container bg-p1 py-12 sm:py-20 px-4 sm:px-10 md:px-20 lg:px-40 relative z-10 wow animate__animated animate__fadeInUp">
    <img
      src="assets/images/sliceIcon.png"
      alt=""
      className="absolute -top-4 sm:-top-6 lg:top-0 right-0 h-[60px] sm:h-[80px] lg:h-[120px] -rotate-90"
    />

    <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
      
      <div className="w-full lg:w-1/2">
        <p className="display-3 text-white !leading-[130%]">
          Make Cub Hrm Part Of Your Work And Get Daily Update
        </p>
      </div>

      <div className="w-full lg:w-1/2">
        <form onSubmit="{handleSubmit}" id="#mailto:info@cubhrm.com" className="pt-6 sm:pt-0">
          <div className="flex flex-col gap-4">
            <input
              type="text"
              placeholder="Enter Your Email"
              className="border border-mainTextColor outline-none bg-white py-3 sm:py-4 px-4 md:px-8 w-full"
            />
            <textarea
              placeholder="Add Your Description"
              className="border border-mainTextColor outline-none bg-white py-3 sm:py-4 px-4 md:px-8 w-full"
            />
            <button
              type="submit"
              className="border border-mainTextColor bg-s2 text-white py-3 sm:py-4 px-4 md:px-8 font-medium"
            >
              Subscribe Now
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section> */}
      <Footer id="contact" />
      <button
        className="fixed text-white text-xl sm:text-2xl rounded-full bg-p1 hover:bg-s2 border border-p1 hover:border-white right-6 md:right-10 p-2 sm:p-3 z-40 jumping1 duration-700 scrollButton scrollButtonHide !leading-[0]"
        aria-label="bottom to top button"
        onClick={handleClick}
      >
        <span className="block">
          <ArrowUp />
        </span>
      </button>

      {showDemoModal && <BookDemoModal onClose={() => setShowDemoModal(false)} />}
    </div>
  );
};

export default LandingPage;
